import React from 'react';
import './Home.css';

  export const Home = () => {
    return (
      <div className="home-container">
        <h2>Welcome to your friendly online grocery store</h2>
        <h3>Search for the food you're looking for and add to your cart as you shop!</h3>
      </div>
    );
  };
